
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Fab from '@material-ui/core/Fab';
import logoDashboard from "../assets/img/logo__dashboard.png";



const useStyles = makeStyles((theme) => ({
	modalClass: {
		position: "absolute",
		height: '100vh',
		zIndex: 1500,
		width: '90vw',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		textAlign: 'center',
		justifyContent: 'center',
	},
	wrapper: {
		display: 'inline-block',
		height: '50px',
		margin: '0 auto',
		width: '50px',
	  	position: 'relative',
		top: 'calc(50% - 70px/2)',
	},
	buttonSuccess: {
	  backgroundColor: green[500],
	  '&:hover': {
		backgroundColor: green[700],
	  },
	},
	fabProgress: {
	  color: '#367fa9',
	  position: 'absolute',
	  top: -6,
	  left: -6,
	  zIndex: 1,
	},
  }));




const LoadingModal = ({show, setShow, changeCompany=false}) => {
	const classes = useStyles();

	return (
		<div className={classes.modalClass}>
  
			<div className={classes.wrapper}>
				<Fab
					aria-label="save"
				>
					<img
						width={50}
						src={logoDashboard}
						alt="s10 Logo"
						className="brand-image img-circle elevation-3"
						style={{opacity: 0.8}}
					/>
				</Fab>
				<CircularProgress size={68} className={classes.fabProgress} />
				Cargando...
			</div>
	  </div>
	)
}

export default LoadingModal
